import React from 'react'

import { Slide } from '../../../../routes/Home/Old/types'
import DoubleClaim from './DoubleClaim'
import Background from './styles/Background'
import { SlideContainer } from './styles/Container'
import { Logo } from './styles/Logo'
import { getShouldLoadBackground } from './utils'

type Props = Slide & {
  active: boolean
  transitionEndHandler: () => void
  transitioning: boolean
  url: string
  next: boolean
}

export function SingleSlide({ media, active, transitionEndHandler, transitioning, title, url, next }: Props) {
  const shouldLoadImages = getShouldLoadBackground(active, next)

  const clickHandler = url
    ? () => {
        window.location.href = url
      }
    : undefined

  return (
    <SlideContainer
      transitioning={transitioning}
      onTransitionEnd={transitionEndHandler}
      active={active}
      onClick={clickHandler}
      clickable={!!url}
    >
      <Background
        shouldLoadBackground={shouldLoadImages}
        media={media}
      />
      <Logo
        active={active}
        shouldLoadLogo={shouldLoadImages}
        media={media}
      />
      <DoubleClaim
        active={active}
        title={title || ''}
        clickHandler={clickHandler}
      />
    </SlideContainer>
  )
}
